<template>
  <li :class="{ active: keyChild === activeIndexChild }">
    <router-link
      :to="`/category/${child.my_soco_sql_id}/${$options.filters.slug(child.name)}`"
      @click.native="selectChild"
      >{{ child.name }}</router-link
    >
  </li>
</template>

<script>
/* eslint-disable vue/require-prop-types */
export default {
  name: 'item-child',
  props: {
    grandParent: {
      required: true,
    },
    parent: {
      required: true,
    },
    keyChild: {
      required: true,
    },
    child: {
      required: true,
    },
  },
  computed: {
    activeIndexChild() {
      return this.$store.state.header.mobile.activeIndexChild;
    },
  },
  methods: {
    selectChild() {
      this.$store.commit('updateActiveIndexChild', this.keyChild);
      this.$store.commit('updatePrimaryMenuMobile', '');
      this.$store.commit('updateActiveIndexGrandParent', -1);
      this.$store.commit('updateActiveIndexParent', -1);
      this.$store.commit('updateActiveIndexChild', -1);
    },
  },
};
</script>
